import { render, staticRenderFns } from "./BOLLabel.vue?vue&type=template&id=3d09a2d2&scoped=true"
import script from "./BOLLabel.vue?vue&type=script&lang=js"
export * from "./BOLLabel.vue?vue&type=script&lang=js"
import style0 from "./BOLLabel.vue?vue&type=style&index=0&id=3d09a2d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d09a2d2",
  null
  
)

export default component.exports